export const serverUrl = {
  u: "https://subscriptioncloud.alistetechnologies.com",
  s: "https://int.alistetechnologies.com",
  test: "https://test.alistetechnologies.com:8443",
  giftr:"https://2qyi1bq4zh.execute-api.ap-south-1.amazonaws.com/default"
};
